import Vue from 'vue'
// import {wordData_dealer} from '../utils/word_dealer.js'
/*
    全局filters
*/

// 价格转换为保留两位小数
Vue.filter('price', function (value) {
    if (!value) return ''
    if (!/^(\d*)(\.\d{1,})?$/.test(value)) return ''
    return parseFloat(value).toFixed(2)
})

// 价格转换为保留两位小数
Vue.filter('tablePrice', function (value) {
    if (!value) return '/'
    if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '/'
    return parseFloat(value).toFixed(2)
})


// 计算供应商结算价格  -- 由于分润比例变动，该方法不适用了
// Vue.filter('settlePrice', function (value) {
//     if (!value) return '--'
//     if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '--'
//     let resResult = parseFloat(value * 0.6 * 0.97).toFixed(2)
//     return resResult
// })

// 销售商 获取锁仓订单状态文字
// Vue.filter("getLockStateStr",function(val){
//     let result=''
//     if(val){
//         wordData_dealer.lockOrderState.forEach(function(item,index){
//             if(item.value==val){
//                 result=item.text
//                 return false
//             }
//         })
//     return result
//     }
// })
// 销售商 清算页面状态
// Vue.filter("getLiquidationState",function(val){
//     let result=''
//     if(val){
//         wordData_dealer.liquidationState.forEach(function(item,index){
//             if(item.value==val){
//                 result=item.text
//                 return false
//             }
//         })
//     return result
//     }
// })